import React, {useCallback, useState, useMemo} from 'react';

function Events({ events }) {
  const [currentDateFilter, setDateFilter ] = useState('upcoming');
  const [currentMonth, setmonth ] = useState('Monat');
  const [currentTopic, setTopic ] = useState('all');
  const [currentPlace, setPlace ] = useState('all');
  const [visibleItems, setVisibleItems ] = useState(4);

  const showMoreItems = useCallback(() => {
    setVisibleItems(state => state + 4);
  }, []);

  const months = useMemo(() => {
    return [
      'Monat',
      ...Object.entries(
        events
        .reduce((carry, event) => ({
          ...carry,
          [event.month]: event.month,
        }), [])
        )
        .map(item => item[1])
        .filter(item => item),
    ];
  }, [events]);

  const topics = useMemo(() => {
    return [
      {
        term_id: 'all',
        term_name: 'Alle',
      },
      ...Object.entries(events
      .reduce((carry, event) => {
        return carry.concat(event.topic);
      }, [])
      .reduce((carry, item) => ({
        ...carry,
        [item.term_id]: item.term_name,
      }), []))
      .map(item => ({
        term_id: item[0],
        term_name: item[1],
      })),
    ];
  }, [events]);

  const places = useMemo(() => {
    return [
      {
        term_id: 'all',
        term_name: 'Ort',
      },
      ...Object.entries(events
        .reduce((carry, event) => {
          return carry.concat(event.place);
        }, [])
        .reduce((carry, item) => ({
          ...carry,
          [item.term_id]: item.term_name,
        }), []))
        .map(item => ({
          term_id: item[0],
          term_name: item[1],
        })),
    ];
  }, [events]);

  if(currentDateFilter !== 'all') {
    events = events.filter(item => item.isUpcoming === (currentDateFilter === 'upcoming'));
  }

  if(currentMonth !== 'Monat') {
    events = events.filter(item => item.month === currentMonth);
  }

  if(currentTopic !== 'all') {
    events = events.filter(item => item.topic.find(topic => topic.term_id === currentTopic));
  }

  if(currentPlace !== 'all') {
    events = events.filter(item => item.place.find(place => place.term_id === currentPlace));
  }

  const availableItems = events.length;

  events = events.slice(0, visibleItems);

  //
  return (
      <section className="section section--reversed">
        <div className="section__content">
          {
            events.map((item, key) =>
              <div key={item.title} className={`article article--auto-height ${ (key + 1) === visibleItems && availableItems > visibleItems && 'article--preview'}`}>
                <figure className="article__image article__image--base" style={{backgroundImage: `url(${item.previewImage})`}}></figure>
                <div className="article__content">
                  <div className="article__body">
                    <div className="article__entry">
                      <p>{ item.formattedDate }</p>

                      <p>
                        <i className="ico-monitor article__ico-monitor">
                          <img src={item.iconPath} alt="" />
                        </i>
                        { item.place.map(item => item.term_name) }
                      </p>
                    </div >

                    <h2>{ item.title }</h2>

                    <a href={ item.permalink } className="btn article__btn">Infos & Anmeldung</a>
                  </div>
                </div>
                { (key + 1) === visibleItems && availableItems > visibleItems && <div className={'article__preview-bg'}></div>}
              </div>
            )
          }
        </div>

        <div className="section__aside section__aside--reversed">
            <div className="navbar">
                <h3>Veranstaltungen filtern:</h3>

                <div className="navbar__content">
                    <div className="select select--highlight">
                        <select aria-label={'Zeitpunkt auswhählen'} name="field-upcoming" id="field-upcoming" onChange={(event) => setDateFilter(event.target.value)}>
                            <option value="upcoming">Bevorstehende</option>
                            <option value="past">Vergangene</option>
                            <option value="all">Alle</option>
                        </select>
                    </div>

                    <div className="select">
                        <select aria-label={'Monat auswhählen'} name="field-month" id="field-month" onChange={(event) => setmonth(event.target.value)}>
                          {
                            months.map(item =>
                              <option key={item} value={item}>
                                {item}
                              </option>
                            )
                          }
                        </select>
                    </div>

                    <div className="select">
                        <select aria-label={'Ort auswhählen'} name="field-place" id="field-place" onChange={(event) => setPlace(event.target.value)}>
                          {
                            places.map(item =>
                              <option key={item.term_id} value={item.term_id}>
                                {item.term_name}
                              </option>
                            )
                          }
                        </select>
                    </div>
                </div>

                <nav className="nav">
                    <ul className="nav__list">
                      {
                        topics.map(item =>
                          <li onClick={() => setTopic(item.term_id)} key={item.term_id} className={`nav__list-item ${item.term_id === currentTopic && 'nav__list-item--alt'}`}>
                            {item.term_name}
                          </li>
                          )
                      }
                    </ul>
                </nav>
            </div>
        </div>
        <div className="events__read-more-teaser">
          {
            availableItems > visibleItems &&
            <a className="btn btn--alt" onClick={showMoreItems}>Mehr anzeigen</a>
          }
        </div>
    </section>
  );
}

export default Events;
